// extracted by mini-css-extract-plugin
export default {"home":"Main_home__QPNgb","portfolio":"Main_portfolio__Vvn2i"};